<template>
  <v-tooltip top color="#004D40">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item :key="widget.name" v-bind="attrs" v-on="on">
        <v-list-item-icon>
          <v-icon medium
            >mdi-office-building-marker-outline</v-icon
          >
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title
            v-text="widget.name"
          ></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <span v-text="widget.name"></span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

export default {
  name: 'widgetComponent',
  components: {

  },
  data() {
    return {

    }
  },
  props: {
    widget: {
      required: true,
      type: Object,
      default: {
        name: ""
      }
    }
  },
  methods: {}
}
</script>

<style scoped>

.v-icon {
  color: #E0F2F1;
}

.v-list-item__title {
  color: #E0F2F1;
}

.v-list-item:hover {
  background-color: #00695C;
}

.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 5px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Widget/Widget.vue